/* eslint-disable react-hooks/exhaustive-deps */
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Avatar from "@mui/material/Avatar";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
import avatarImg from "../../assets/images/avatar.png";
import merchantLogo from "../../assets/images/merchantLogo.png";
import style from "./Login.module.css";

import SuperDistributorDashboard from "../../pages/SuperDistributorDashboard/SuperDistributorDashboard";
//banner images

import "react-responsive-carousel/lib/styles/carousel.min.css";
import Footer from "../Commons/Footer/Footer";

import Button from "@mui/material/Button";

//api calling imports
import { connect, useDispatch } from "react-redux";
import * as actionCreators from "../../redux/actions/user";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Commons/Loader/Loader";

import swal from "sweetalert";
import {
  apiFormatGetFullCtrl,
  apiFormatPostFullCtrlInjson,
} from "../../Api/ApiFormat";
import { PreventSqlInjection } from "../../Utils/PreventSqlInjection";
import Popup from "../Commons/Popup/Popup";
import IAgreePopup from "./IAgreePopup/IAgreePopup";
import NewPassGenerate from "./NewPassGenerate/NewPassGenerate";
import OTPPopup from "./OTPPopup/OTPPopup";
import FingerprintJS from "fingerprintjs2";
import axios from "axios";
import queryStr from "qs";
import * as Api from "../../Api/Api";
import * as actionTypes from "../../redux/actions/actionTypes";

function Login(props) {
  const [focus1, setFocus1] = useState(false);
  const [focus2, setFocus2] = useState(false);
  const [eyePass, setEyePass] = useState(false);
  const [iAgreePopupShow, setIAgreePopupShow] = useState(false);
  const [ShowNewPassGeneratePopup, setShowNewPassGeneratePopup] =
    useState(false);
  const [ShowOnlyOTPPopup, setShowOnlyOTPPopup] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [data, setData] = useState({
    username: "",
    pass: "",
    consent: false,
    longitude: "",
    latitude: "",
  });

  const onChangeHandleLogin = (e) => {
    let name = e.target.name;
    let val = e.target.value;

    if (val.length <= 20) {
      setData({ ...data, [name]: val });
    }
  };

  const onChangeCheckBoxHandler = (e) => {
    let name = e.target.name;
    let val = e.target.checked;

    setData({ ...data, [name]: val });
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (props.DashboardData.error.errorCode === "404") {
      toast.error(props.DashboardData.error.msg);
    }

    if (props.DashboardData.error.msg === "something went wrong") {
      toast.error(props.DashboardData.error.msg);
    }
    if (props.DashboardData.error.msg === "Account blocked") {
      toast.error(props.DashboardData.error.msg);
    }
  }, [props.DashboardData]);

  //login auth

  useEffect(() => {
    if (!sessionStorage.getItem("access_token")) {
      navigate("/login");
    } else if (sessionStorage.getItem("access_token")) {
      navigate("/retailer/dashboard");
    } else {
      navigate("/login");
    }
  }, [sessionStorage.getItem("access_token")]);

  const successCallback = (position) => {
    localStorage.setItem("longitude", position.coords.longitude);
    localStorage.setItem("latitude", position.coords.latitude);
    setData({
      ...data,
      longitude: position.coords.longitude,
      latitude: position.coords.latitude,
    });
  };

  const errorCallback = (error) => {
    if (error.message.toLowerCase() === "user denied geolocation") {
      setData({ ...data, longitude: false, latitude: false });
    }
  };
  const setUniqueIdentifierFunc = async () => {
    let deviceId = await generateDeviceIdentifier();
    setUniqueIdentifier(deviceId);
  };
  useEffect(() => {
    setUniqueIdentifierFunc();
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  }, []);
  const [uniqueIdentifier, setUniqueIdentifier] = useState("");
  const generateDeviceIdentifier = async () => {
    const components = await FingerprintJS.getPromise();
    const values = components.map((component) => component.value);
    const deviceIdentifier = FingerprintJS.x64hash128(values.join(""), 31);
    return deviceIdentifier;
  };
  const dispatch = useDispatch();
  const LoginStart = () => {
    return {
      type: actionTypes.LOGIN_START,
    };
  };
  const LoginSuccess = (data) => {
    return {
      type: actionTypes.LOGIN_SUCCESS,
      data,
    };
  };
  const LoginFail = (err) => {
    return {
      type: actionTypes.LOGIN_FAIL,
      err,
    };
  };
  
  const LoginFunc = async () => {
    setIsloading(true);

    try {
      if (data.username === "") {
        toast.error("Please fill the userName field!");
      } else if (data.username.length > 15) {
        toast.error("Username should be less than 15 digits!");
      } else if (data.pass === "") {
        toast.error("Please fill the Password feild!");
      } else if (data.pass.length > 20) {
        toast.error("Password should be less than 20 digits!");
      } else if (data.consent === false) {
        toast.error("Please agree terms of use");
      } else if (data.username.toLowerCase() === "admin") {
        toast.error("Admin can't login here!");
      } else if (data.longitude === false) {
        toast.error("User denied geolocation permission!");
      } else {
        if (PreventSqlInjection(data.username)) {
          throw new Error("UnAuthorized Access!");
        }
        if (PreventSqlInjection(data.pass)) {
          throw new Error("UnAuthorized Access!");
        }
        // props.onUserLogin(uniqueIdentifier, data, navigate);
        // dispatch(LoginStart());

        try {
          //green token
          const userIp = await axios.get("https://api.ipify.org?format=json");
          const res = Api.greenTokenApiCallPostFunction(
            "POST",
            `${process.env.REACT_APP_SITE_PRODUCTION_URL + "greenAuthtoken"}`,
            "application/x-www-form-urlencoded",
            {
              client_secret: window.btoa(process.env.REACT_APP_CLIENT_SECRET),
              client_id: window.btoa(process.env.REACT_APP_CLIENT_ID),
              UserName: data.username,
              Password: data.pass,
              longitude: data.longitude,
              latitude: data.latitude,
              grant_type: "password",
              deviceId: uniqueIdentifier,
            },
            {
              headers: {
                "X-MS-Client-IP": userIp.data.ip,  // Add IP to the request headers
              }
            }
          );

          const finaldata = await res;
          if (finaldata && finaldata !== "Unauthorized") {
            if (finaldata.data) {
              //timer
              var dateOne = new Date(),
                dateTwo = new Date(dateOne);
              let mintToAdd =
                parseInt(Number(finaldata.data.expires_in) / 60) - 5;
              dateTwo.setMinutes(dateOne.getMinutes() + mintToAdd);

              sessionStorage.setItem("timer", dateTwo);

              //login

              const loginRes = await axios(
                `${
                  process.env.REACT_APP_SITE_PRODUCTION_URL + "api/user/login"
                }`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "access-control-allow-origin": "*",
                    authorization: "Bearer " + finaldata.data.access_token,
                  },
                  data: queryStr.stringify({
                    UserName: data.username,
                    Password: data.pass,
                    longitude: data.longitude,
                    latitude: data.latitude,
                    source: "Web",
                    OTP: uniqueIdentifier,
                  }),
                }
              );

              let userData = loginRes;

              if (userData.data.errorCode === "200") {
                if (userData.data.data.ActiveStatus === "Yes") {
                  if (userData.data.data.Status === "Active") {
                    if (userData.data.data.Role === "R") {
                      sessionStorage.setItem(
                        "access_token",
                        finaldata.data.access_token
                      );
                      sessionStorage.setItem("role", userData.data.data.Role);
                      sessionStorage.setItem(
                        "profilePic",
                        userData.data.data.ProfilePic
                      );
                      sessionStorage.setItem("name", userData.data.data.Name);
                      sessionStorage.setItem(
                        "userId",
                        userData.data.data.UserId
                      );
                      sessionStorage.setItem(
                        "username",
                        userData.data.data.Username
                      );
                      sessionStorage.setItem(
                        "emailId",
                        userData.data.data.emailId
                      );
                      sessionStorage.setItem(
                        "retMobile",
                        userData.data.data.MobileNo
                      );
                      sessionStorage.setItem(
                        "access_token",
                        finaldata.data.access_token
                      );
                      sessionStorage.setItem(
                        "expires_in",
                        finaldata.data.expires_in
                      );
                      sessionStorage.setItem(
                        "refresh_token",
                        finaldata.data.refresh_token
                      );
                      navigate("/retailer/Dashboard");
                      dispatch(LoginSuccess(userData.data.data));
                      var investorRes = await apiFormatGetFullCtrl(
                        "api/invest/investorDashBoard/",
                        userData.data.data.UserId
                      );
                      if (investorRes && investorRes.data.errorCode === "300") {
                      } else if (
                        investorRes &&
                        investorRes.data.errorCode === "200"
                      ) {
                        sessionStorage.clear();
                        navigate("/login");
                        toast.error(
                          "Investor Login is not enabled for web portal."
                        );
                      } else {
                        sessionStorage.clear();
                        navigate("/login");
                        toast.error("Error occured in login.");
                      }
                    } else if (userData.data.data.Role === "D") {
                      sessionStorage.setItem(
                        "profilePic",
                        userData.data.data.ProfilePic
                      );
                      sessionStorage.setItem("name", userData.data.data.Name);
                      sessionStorage.setItem("role", userData.data.data.Role);
                      sessionStorage.setItem(
                        "userId",
                        userData.data.data.UserId
                      );
                      sessionStorage.setItem(
                        "username",
                        userData.data.data.Username
                      );
                      sessionStorage.setItem(
                        "retMobile",
                        userData.data.data.MobileNo
                      );
                      sessionStorage.setItem(
                        "access_token",
                        finaldata.data.access_token
                      );
                      sessionStorage.setItem(
                        "expires_in",
                        finaldata.data.expires_in
                      );
                      sessionStorage.setItem(
                        "refresh_token",
                        finaldata.data.refresh_token
                      );

                      navigate("/distributor/Dashboard");
                      dispatch(LoginSuccess(userData.data.data));
                    } else if (userData.data.data.Role === "SD") {
                      sessionStorage.setItem(
                        "profilePic",
                        userData.data.data.ProfilePic
                      );
                      sessionStorage.setItem("name", userData.data.data.Name);

                      sessionStorage.setItem("role", userData.data.data.Role);

                      sessionStorage.setItem(
                        "userId",
                        userData.data.data.UserId
                      );
                      sessionStorage.setItem(
                        "username",
                        userData.data.data.Username
                      );
                      sessionStorage.setItem(
                        "retMobile",
                        userData.data.data.MobileNo
                      );
                      sessionStorage.setItem(
                        "access_token",
                        finaldata.data.access_token
                      );
                      sessionStorage.setItem(
                        "expires_in",
                        finaldata.data.expires_in
                      );
                      sessionStorage.setItem(
                        "refresh_token",
                        finaldata.data.refresh_token
                      );

                      navigate(
                        "/SuperDistributorDashboard/SuperDistributorDashboard"
                      );
                      dispatch(LoginSuccess(userData.data.data));
                    }
                  } else {
                    toast.error("Account is Blocked. Please contact admin!");
                    dispatch(
                      LoginFail({
                        msg: "Account is Blocked. Please contact admin!",
                      })
                    );
                  }
                } else {
                  toast.error(
                    "KYC is pending. Please contact support for help!"
                  );
                  dispatch(
                    LoginFail({
                      msg: "KYC is pending. Please contact support for help!",
                    })
                  );
                }
              }
            } else {
              toast.error(
                "Invalid Login Credentials,please check login Details!"
              );
              dispatch(LoginFail({ msg: "Login Failed,invalid credentials!" }));
            }
          } else if (finaldata === "Unauthorized") {
            const apiResp = await apiFormatPostFullCtrlInjson(
              "api/user/GetOtpV2",
              {
                username: data.username,
              }
            );
            if (apiResp) {
              if (apiResp.data) {
                if (apiResp.data.errorCode === "200") {
                  setShowNewPassGeneratePopup(true);
                } else if (apiResp.data.errorCode === "404") {
                  sessionStorage.clear();
                  throw new Error(
                    apiResp.data.msg ?? "Some Error Ocuurred In Login Process!"
                  );
                } else if (apiResp.data.errorCode === "500") {
                  setShowOnlyOTPPopup(true);
                } else {
                  sessionStorage.clear();
                  throw new Error("Some Error Ocuurred In Login Process!");
                }
              } else {
                throw new Error("Some Error Ocuurred In Login Process!");
              }
            } else {
              throw new Error("Some Error Ocuurred In Login Process!");
            }
            // toast.error("Invalid Login Credentials,please check login Details!");
            // dispatch(LoginFail({ msg: "Login Failed,invalid credentials!" }));
          } else {
            dispatch(LoginFail("Incorrect Username or Password"));
            toast.error("Incorrect Username or Password");
          }
        } catch (err) {
          dispatch(LoginFail(err.message));
          toast.error("Some error occurred in login process");
        }
      }
    } catch (err) {
      swal("Oops!", err.message.toLowerCase(), "error");
    }

    setIsloading(false);
  };
  const forgotPassClickHandler = async () => {
    setIsloading(true);

    try {
      if (data.username === "") {
        toast.error("Please fill the userName field!");
      } else if (data.username.length > 15) {
        toast.error("Username should be less than 15 digits!");
      } else {
        if (PreventSqlInjection(data.username)) {
          throw new Error("UnAuthorized Access!");
        }
        if (PreventSqlInjection(data.pass)) {
          throw new Error("UnAuthorized Access!");
        }
        //props.onUserLogin(uniqueIdentifier, data, navigate);
        // dispatch(LoginStart());

        try {
          const apiResp = await apiFormatPostFullCtrlInjson(
            "api/user/GetOtpV2",
            {
              username: data.username,
            }
          );
          if (apiResp) {
            if (apiResp.data) {
              if (
                apiResp.data.errorCode === "200" ||
                apiResp.data.errorCode === "500"
              ) {
                setShowNewPassGeneratePopup(true);
              } else if (apiResp.data.errorCode === "404") {
                sessionStorage.clear();
                throw new Error(
                  apiResp.data.msg ?? "Some Error Ocuurred In Login Process!"
                );
              } else {
                sessionStorage.clear();
                throw new Error("Some Error Ocuurred In Login Process!");
              }
            } else {
              throw new Error("Some Error Ocuurred In Login Process!");
            }
          } else {
            throw new Error("Some Error Ocuurred In Login Process!");
          }
          // toast.error("Invalid Login Credentials,please check login Details!");
          // dispatch(LoginFail({ msg: "Login Failed,invalid credentials!" }));
        } catch (err) {
          dispatch(LoginFail(err.message));
          toast.error("Some error occurred in login process");
        }
      }
    } catch (err) {
      swal("Oops!", err.message.toLowerCase(), "error");
    }

    setIsloading(false);
  };

  return (
    <>
      {isLoading && <Loader />}
      {props.user.isLoading && <Loader />}

      {ShowNewPassGeneratePopup && (
        <NewPassGenerate
          resetForm={() => {
            setData({
              ...data,
              username: "",
              pass: "",
              consent: false,
            });
          }}
          uname={data.username}
          close={() => {
            setShowNewPassGeneratePopup(false);
          }}
        />
      )}

      {ShowOnlyOTPPopup && (
        <OTPPopup
          isLoading={isLoading || props.user.isLoading}
          loginFunc={LoginFunc}
          Password={data.pass}
          Username={data.username}
          deviceId={uniqueIdentifier}
          close={() => {
            setShowOnlyOTPPopup(false);
          }}
        />
      )}

      <div className={style.LoginContainer}>
        <div className={style.LoginContainer_sec2}>
          <div className={style.merchantLogo}>
            <img src={merchantLogo} alt="Merchant Logo" />
          </div>
          <div className={style.LoginContainer_sec2_login_form}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                LoginFunc();
              }}
            >
              <div className={style.LoginContainer_sec2_profile}>
                <Avatar
                  className={style.avatar_img}
                  style={{ margin: "auto", marginTop: "0px" }}
                  sx={{ width: 87, height: 87 }}
                  src={avatarImg}
                />
                <h1>Welcome</h1>
              </div>

              <div
                className={`${style.LoginContainer_sec2_div} ${
                  (focus1 || data.username) && style.focus1
                }`}
              >
                {" "}
                <PersonIcon className={style.formIcon} />{" "}
                <div>
                  {" "}
                  <p>Username</p>{" "}
                  <input
                    type="text"
                    value={data.username}
                    name={"username"}
                    onFocus={() => setFocus1(true)}
                    onBlur={() => setFocus1(false)}
                    onChange={onChangeHandleLogin}
                    autoComplete={"off"}
                  />{" "}
                  <h2></h2>{" "}
                </div>{" "}
              </div>
              <div
                className={`${style.LoginContainer_sec2_div}  ${
                  (focus2 || data.pass) && style.focus2
                }`}
                style={{ display: "flex" }}
              >
                {" "}
                <LockIcon className={style.formIcon} />{" "}
                <div>
                  {" "}
                  <p>Password</p>{" "}
                  <input
                    type={eyePass ? "text" : "password"}
                    value={data.pass}
                    name={"pass"}
                    onFocus={() => setFocus2(true)}
                    onBlur={() => setFocus2(false)}
                    onChange={onChangeHandleLogin}
                    autoComplete={"off"}
                  />
                  {data.pass && (
                    <>
                      {eyePass ? (
                        <VisibilityOffIcon
                          className={style.eyeIcon}
                          onClick={() => {
                            setEyePass(!eyePass);
                          }}
                        />
                      ) : (
                        <VisibilityIcon
                          className={style.eyeIcon}
                          onClick={() => {
                            setEyePass(!eyePass);
                          }}
                        />
                      )}
                    </>
                  )}
                  <h2 className={`${data.pass && style.conflicted}`}></h2>
                </div>{" "}
              </div>

              <div className={style.consent}>
                <Checkbox
                  checked={data.consent}
                  name="consent"
                  {...label}
                  onChange={onChangeCheckBoxHandler}
                />
                <p>
                  I agree{" "}
                  <a
                    href="#"
                    onClick={() => {
                      setIAgreePopupShow(true);
                    }}
                  >
                    Terms of use
                  </a>
                </p>
              </div>

              <p
                className={style.forgotPass}
                // onClick={() =>
                //   swal(
                //     "Oops",
                //     "Please Contact Admin For Forgot Password!",
                //     "error"
                //   )
                // }
                onClick={forgotPassClickHandler}
              >
                Forgot Password<p>?</p>
              </p>

              <Button className={style.loginBtn} type="submit">
                Login
              </Button>
            </form>
          </div>
        </div>
      </div>

      <Footer hideIconSidebar={true} />

      {props.user.sessionMsg && (
        <Popup
          head={""}
          msg={"Session timed out. Please login again!"}
          err={false ? "no" : "yes"}
          oKFunc={() => {
            props.onSessionType({ what: false });
            sessionStorage.clear();
            navigate("/login");
          }}
          style={{ zIndex: "999999999" }}
        />
      )}

      {iAgreePopupShow && (
        <IAgreePopup close={setIAgreePopupShow} val={data} setVal={setData} />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer,
    DashboardData: state.dashboardReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUserLogin: (OTP, data, navigate) =>
      dispatch(actionCreators.LoginMainFunc(OTP, data, navigate)),
    onSessionType: (data) => dispatch(actionCreators.sessionType(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
